// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__Pf_TV","content":"RecentSearches_content__3RX-i"};